import { useState, useEffect } from 'react';
export var useShouldShowComponent = function (_a) {
    var queryName = _a.queryName;
    var _b = useState(null), data = _b[0], setData = _b[1];
    useEffect(function () {
        window.LIFE_CYCLE_EVENT_BUS.on('data-sources.data', function (_a) {
            var output = _a.output;
            if (output.queryName === queryName) {
                setData(output.data[queryName]);
            }
        });
    }, [queryName]);
    return { data: data };
};
